module.exports = __webpack_public_path__ + "resources/img/banner-3.561e490a.jpg";